import React from "react";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";

const getOSType = (): "Android" | "iOS" | "unknown" => {
  const userAgent = navigator.userAgent.toLowerCase();

  if (userAgent.indexOf("android") > -1) return "Android";
  if (
    userAgent.indexOf("iphone") > -1 ||
    userAgent.indexOf("ipad") > -1 ||
    userAgent.indexOf("ipod") > -1
  )
    return "iOS";

  return "unknown";
};

const Container = styled.button({
  cursor: "pointer",
});

const ShareButton = () => {
  const theme = useTheme();

  const os = getOSType();

  const handleShare = () => {
    const title = document.title;
    const url = window.location.href;
    const text = "Check out this page!";

    if (os === "Android") {
      window.android.share(title, text, url);
    } else if (navigator.share) {
      navigator
        .share({
          title: document.title,
          url: window.location.href,
          text: "Check out this page!",
        })
        .then(() => console.log("Successfully shared"))
        .catch((error) => console.error("Error sharing:", error));
    } else {
      alert("Sharing is not supported in this browser.");
    }
  };

  return (
    <Container onClick={handleShare}>
      <Image src={theme.image.share_icon.default} alt="Share" />
    </Container>
  );
};

export default ShareButton;
